import Vue from "vue";

// Configuration
import "./config/cookie.config";
import "./config/fragment.config";
import "./config/vue-quill.config";
import "./config/vue-mention.config";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./registerServiceWorker";

// Filter
import "./filter/currency.filter";
import "./filter/date.filter";
import ErrorFilter from "./filter/error.filter";
import "./filter/case.filter";

// Constant
import {
  CHECK_AUTH,
  FORCE_LOGOUT,
  FETCH_CONNECTED
} from "./store/constants/actions.type";
import { SET_PRIVILEGE } from "./store/constants/mutations.type";
import { LOGIN, ERROR_PAGE } from "./router/names.type";
import { MAINTENANCE } from "./router/maintenance.type";

// Prototype
import moment from "moment";
import _ from "lodash";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "$_", { value: _ });
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);

// Component
import DialogConfirm from "./components/Dialog/Confirm";
Vue.use(DialogConfirm);

const isDev = process.env.NODE_ENV !== "production";
Vue.config.devtools = isDev;
Vue.config.performance = isDev;
Vue.config.productionTip = false;
Vue.filter("error", ErrorFilter);

// Vue Mixin
import "./mixin";

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  handleRouteNotFound(to, from, next);
  handlePrivilege(to);
  handleUrlPrivilege(to, next);
  handleMaintenance(to, next);
  handleAuthentication(to, next);
});

function handleRouteNotFound(to, from, next) {
  let route = router.resolve(to);
  if (route.resolved.matched.length === 0) {
    if (
      from.name === ERROR_PAGE.PAGE404 ||
      from.name === ERROR_PAGE.PAGE404_CONTENT
    ) {
      next();
    } else {
      next({
        name: store.getters.isAuthenticated
          ? ERROR_PAGE.PAGE404_CONTENT
          : ERROR_PAGE.PAGE404
      });
    }
  }
}

function handlePrivilege(to) {
  if (to && to.meta.privilege) {
    store.commit(SET_PRIVILEGE, to.meta.privilege);
  }
}

function handleUrlPrivilege(to, next) {
  if (
    to &&
    store.getters.isAuthenticated &&
    to.matched.some(record => record.meta.privilege)
  ) {
    !store.getters.privilege && next({ name: ERROR_PAGE.PAGE404_CONTENT });
  }
}

function handleMaintenance(to, next) {
  if (MAINTENANCE && MAINTENANCE[process.env.VUE_APP_MODE]?.includes(to.name)) {
    next({
      name: store.getters.isAuthenticated
        ? ERROR_PAGE.PAGE503_CONTENT
        : ERROR_PAGE.PAGE503
    });
  }
}

function handleAuthentication(to, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      handleLogoutAndRedirect(next);
    } else {
      Promise.all([store.dispatch(CHECK_AUTH)]).then(next);
    }
  } else {
    next();
  }
}

function handleLogoutAndRedirect(next) {
  store.dispatch(FORCE_LOGOUT).then(() => {
    const loginpath = window.location.pathname;
    const loginsearch = window.location.search;
    next({
      name: LOGIN,
      query: { pathname: loginpath, search: loginsearch }
    });
    setTimeout(() => {
      store.commit("snackbar/setSnack", {
        show: true,
        message: "Token Expired. Sorry you must login again",
        color: "error"
      });
    }, 500);
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    window.addEventListener("offline", () => {
      store.dispatch(FETCH_CONNECTED, false);
    });
    window.addEventListener("online", () => {
      store.dispatch(FETCH_CONNECTED, true);
    });
  }
}).$mount("#app");
